// This hook returns header height integer if sticky, otherwise returns `0`

import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

export const useCalculateStickyHeaderHeight = () => {
  const [stickyHeaderHeight, setStickyHeaderHeight] = useState(0);

  const handleCalculation = () => (
    setStickyHeaderHeight(document.querySelector('.mn_pageHeader.mn_sticky')?.offsetHeight || 0)
  );
  const throttledCalculation = throttle(handleCalculation, 500);

  useEffect(() => {
    window.addEventListener('scroll', throttledCalculation);

    return () => {
      throttledCalculation.cancel();
      window.removeEventListener('scroll', throttledCalculation);
    };
  }, []);

  return stickyHeaderHeight;
};
